import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import { Col, Row } from "antd";
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
export default class GimbalBanner extends React.Component {
    componentDidMount() {
        
    }

    render() {
        return (
            <div className='gimbal-banner'>
                <div className="gimbal-banner-content">
                    <h1><Texty>视如猛虎，明察秋毫</Texty></h1>
                    <div className="video-container video">
                    <video
                     x5-playsinline="true"
                     playsinline="true" 
                     webkit-playsinline="true"
                    src="http://qiniu.metridynamic.com/video/new%20video/payload/gimbal.mp4" autoPlay loop muted>

                    </video>
                </div>
                </div>
            </div>
        )

    }
}
